import React from 'react'

//import styles from './Label.module.css'

const SchoolFootprintLabel = ({
  ai: {
    attributes: { SCHOOL },
  },
}) => (
  <div>
    <div>{SCHOOL || '[BLANK]'}</div>
  </div>
)

export default SchoolFootprintLabel
